// Данные магазина витрины (docs/04-api-contract.md §3): тема, доступность, тексты.
import type { ApiResponse } from "@shopkit/shared";

import { apiRequest } from "./client";

export type Shop = ApiResponse<"getShop">;

/** getShop загружает магазин по Bearer JWT из tokenStore. Бросает ApiError. */
export function getShop(signal?: AbortSignal): Promise<Shop> {
  return apiRequest<Shop>("/api/v1/shop", { signal });
}
